import { MaintenanceTaskConfigurationFile } from './maintenance-task-configuration-file';
import { Model } from './model';
import { Role } from './role';

export class MaintenanceTaskConfiguration {
  constructor(
    public hash?: string,
    public model?: Model,
    public name?: string,
    public frequencyInDays?: number,
    public duration?: number,
    public hours?: number,
    public startDate?: number,
    public configurationFiles?: MaintenanceTaskConfigurationFile[],
    public roles?: Role[]
  ) { }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/maintenance-task-configuration.ts